import { render } from "./AccessCodePopup.vue?vue&type=template&id=4d86ff3a&scoped=true&ts=true"
import script from "./AccessCodePopup.vue?vue&type=script&lang=ts"
export * from "./AccessCodePopup.vue?vue&type=script&lang=ts"

import "./AccessCodePopup.vue?vue&type=style&index=0&id=4d86ff3a&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d86ff3a"]])

export default __exports__